module.exports = __webpack_public_path__ + "assets/iadt-alt.3b4d0971.svg";